export type BeaconComponentConfig<> = {
  title:  () => string;
  command: () => string;
  deeplinkId: string;
  url: (props?: any) => string;
  // TODO: GUS W-13662478 make sure we have all required icons in right size to display in search Omnibox
  icon: (props: any) => React.ReactSVGElement;
  tags:  () => Array<string>;
  isAdmin: boolean;
};

/**
 * A helper function, used as a workaround to get stronger types when passing specs to createBeaconComponentRegistry
 * @param specs
 */
export function beaconComponentRegistryEntry(specs: BeaconComponentConfig) {
  return specs;
}
